import React from 'react'
import {ModalBase} from '../ModalBase'

const ModalCodigoEnviado = (props: any) => {
  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '500px'}}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l' style={{color: '#13AD90', fontSize: '36px'}}>
              Código enviado
            </h3>
          </div>
          <div className='form-separator'></div>
          <p>Se ha enviado un nuevo código a tu correo electrónico.</p>
          <div className='w-layout-hflex button-actions'>
            <button className='m button w-inline-block' onClick={props.onClose}>
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalCodigoEnviado
